export default __webpack_public_path__ + "static/media/image4pro7.484f4806.jpeg";